<template>
  <div class="v-content">
    <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="80">
      <FormItem label="消息标题" prop="title">
        <Input v-model="formValidate.title" placeholder="请输入" style="width: 300px;" clearable />
      </FormItem>
      <FormItem label="发送对象" prop="tag_group_id">
        <div class="checkbox">
          <Checkbox v-model="checkAll" @on-change="handleCheckAll">全员</Checkbox>
          <CheckboxGroup
            v-if="!checkAll"
            v-model="formValidate.tag_group_id"
            @on-change="cancelCheckAll"
          >
            <Checkbox v-for="(item,index) in tag_list" :key="index" :label="item.id">
              <Icon
                v-if="item.id>4"
                type="ios-close-circle-outline"
                class="delete-tag"
                @click.stop.prevent="deleteTag(item.id)"
              />
              {{item.id==4 ? "": item.title}}
              <Tooltip
                v-if="item.id==4"
                placement="top"
                max-width="200"
                :content="item.title"
              >{{item.title}}</Tooltip>
            </Checkbox>
          </CheckboxGroup>
          <Button v-if="!checkAll" icon="ios-add" @click="moveModal=true;checkAll=false">自选用户</Button>
        </div>
      </FormItem>
      <FormItem label="发送方式" prop="type">
        <CheckboxGroup v-model="formValidate.type">
          <Checkbox label="1">站内信</Checkbox>
          <!-- <Checkbox label="2">极光推送</Checkbox> -->
        </CheckboxGroup>
      </FormItem>
      <FormItem label="消息内容" prop="content">
        <UEditor v-model="formValidate.content"></UEditor>
      </FormItem>
    </Form>
    <div class="submit">
      <Button size="large" @click="goBack">返回</Button>
      <Button size="large" @click="saveNews(1)">保存并返回</Button>
      <Button @click="saveNews(2)" size="large" type="primary">保存并发送</Button>
    </div>
    <Modal :mask-closable="false" class="vertical-center-modal" v-model="moveModal" title="选择用户">
      <Form inline>
        <Form-item>
          <Input style="width:200px" placeholder="请输入用户昵称关键字" v-model="modalCondition.nickname" />
        </Form-item>
        <Form-item class="search-form-btns">
          <div class="btn-wrap form-item-search">
            <Button icon="ios-search" @click="search(0)">搜索</Button>
            <Button icon="md-undo" @click="search(1)">重置</Button>
          </div>
        </Form-item>
      </Form>
      <div class="content">
        <Grid
          ref="grid"
          :columns="column"
          data-url="/api/user"
          :search="modalCondition"
          keyField="uid"
          selectType="multi"
          @onSelectionChange="onSelectionChange"
          :selectedItems="selectedItems"
          keepSelected
        >
          <template slot-scope="{ row }" slot="c1">
            <img class="avatar" :src="row.avatar" />
            <span>{{row.nickname}}</span>
          </template>
        </Grid>
      </div>
      <div slot="footer">
        <Button @click="cancel(0)">取消</Button>
        <Button type="primary" @click="confirm(0)">确定</Button>
      </div>
    </Modal>
    <Modal :mask-closable="false" class="vertical-center-modal" v-model="moveModal1" title="保存">
      <Form>
        <FormItem>
          <RadioGroup v-model="keepTag">
            <Radio label="1">
              <span>存为标签</span>
            </Radio>
            <Radio label="2">
              <span>不保存标签</span>
            </Radio>
          </RadioGroup>
        </FormItem>
        <FormItem v-show="keepTag == 1" label="标签名称">
          <Input v-model="tagName" placeholder="请输入标签名称" />
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="cancel(1)">取消</Button>
        <Button type="primary" @click="confirm(1)">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import UEditor from "@/components/UEditor.vue";
export default {
  name: "MessageEdit",
  components: {
    UEditor
  },
  data() {
    return {
      id: this.$route.query.id || "",
      tag_list: [],
      tag_group_id: [], //全选使用
      checkAll: false,
      selectId: [],
      formValidate: {
        title: "",
        content: "",
        tag_group_id: [],
        type: []
      },
      ruleValidate: {
        title: [
          {
            required: true,
            message: "请输入",
            trigger: "blur"
          }
        ],
        tag_group_id: [
          {
            required: true,
            message: "请选择"
          }
        ],
        type: [
          {
            required: true,
            type: "array",
            message: "请选择",
            trigger: "change"
          }
        ],
        content: [
          {
            required: true,
            message: "请选择",
            trigger: "blur"
          }
        ]
      },
      moveModal: false,
      moveModal1: false,
      modalCondition: {
        nickname: ""
      },
      column: [
        {
          title: "用户昵称",
          key: "nickname",
          slot: "c1",
          minWidth: 140
        },
        {
          title: "手机号",
          key: "mobile",
          align: "center",
          minWidth: 120
        }
      ],
      selectedItems: [],
      tagName: "",
      keepTag: "1"
    };
  },
  created() {
    this.getTag(this.id);
  },
  methods: {
    search(flag) {
      if (flag) {
        this.modalCondition.nickname = "";
      }
      this.$refs.grid.searchRefresh();
    },
    // 返回
    goBack() {
      this.$router.push({
        name: "Message"
      });
    },
    // 详情
    getInfo() {
      if (this.id) {
        this.$http.get(`/api/message/${this.$route.query.id}`).then(res => {
          if (res.tag_group_id == 1) {
            this.checkAll = true;
            this.handleCheckAll();
          } else {
            //   带自选用户的发送对象
            if (res.users) {
              this.selectedItems = res.users;
              let { title, ids } = this.createUserChooseTagParams();
              this.tag_list.push({
                id: "4",
                title,
                ids
              });
              this.tag_group_id.push("4");
            }
            res.tag_group_id = res.tag_group_id.split(",");
          }
          res.type = res.type.split(",");
          this.$nextTick(() => {
            this.formValidate = res;
          });
        });
      }
    },
    // 发送对象
    getTag(id) {
      this.tag_list = [];
      this.tag_group_id = [];
      this.$http.get(`/api/messageTag`).then(res => {
        res.forEach(item => {
          if (item.id != 1 && item.id != 4) {
            item.id = item.id + "";
            this.tag_list.push(item);
            this.tag_group_id.push(item.id);
          }
        });
        if (id) {
          this.getInfo();
        }
      });
    },
    saveNews(is_release) {
      let tag_group_id = "";
      let uid = "0";
      if (this.checkAll == true) {
        tag_group_id = "1";
      } else {
        if (this.formValidate.tag_group_id.length > 0) {
          tag_group_id = [...this.formValidate.tag_group_id];
          //   检索是否含有自选用户
          for (let j = 0; j < tag_group_id.length; j++) {
            if (tag_group_id[j] == 4) {
              for (let i = 0; i < this.tag_list.length; i++) {
                if (this.tag_list[i].id == 4) {
                  uid = this.tag_list[i].ids;
                  break;
                }
              }
              break;
            }
          }
          tag_group_id = tag_group_id.join(",");
        } else {
          this.$Message.error("请选择发送对象");
          return;
        }
      }
      if (!this.formValidate.content) {
        this.$Message.error("请输入消息内容");
        return;
      }
      this.$refs["formValidate"].validate(valid => {
        if (valid) {
          let params = {
            title: this.formValidate.title,
            content: this.formValidate.content,
            type: this.formValidate.type.join(","),
            tag_group_id: tag_group_id,
            is_release: is_release,
            uid: uid
          };
          if (this.id) {
            this.$http.put(`/api/message/${this.id}`, params).then(() => {
              this.goBack();
            });
          } else {
            this.$http.post("/api/message", params).then(() => {
              this.goBack();
            });
          }
        } else {
          this.$Message.error("您有未填项!");
        }
      });
    },
    handleCheckAll() {
      if (this.checkAll) {
        this.formValidate.tag_group_id = [1];
      } else {
        this.formValidate.tag_group_id = [];
      }
    },
    cancelCheckAll() {
      this.indeterminate = false;
      this.checkAll = false;
    },
    onSelectionChange(val) {
      this.selectData = [...val];
    },
    confirm(type) {
      if (type == 1) {
        this.moveModal1 = false;
        // 1 保存 2 不保存
        if (this.keepTag == 1) {
          if (!this.tagName) {
            this.$Message.error("请输入标签名");
            return;
          }
          let uid = [];
          this.selectData.forEach(item => {
            uid.push(item.uid);
          });
          uid = uid.join(",");
          this.$http
            .post(`/api/messageTag`, {
              title: this.tagName,
              uid: uid
            })
            .then(res => {
              this.tag_list.push({ id: res.tag_id, title: this.tagName });
              this.tag_group_id.push(res.tag_id);
              this.formValidate.tag_group_id.push(res.tag_id);
            });
        } else {
          this.selectedItems = this.selectData;
          let { title, ids } = this.createUserChooseTagParams();
          for (let i = 0; i < this.tag_list.length; i++) {
            if (this.tag_list[i].id == "4") {
              this.tag_list[i].title = title;
              this.tag_list[i].ids = ids;
              return;
            }
          }
          this.tag_list.push({
            id: 4,
            title,
            ids
          });
          this.tag_group_id.push(4);
          this.formValidate.tag_group_id.push(4);
        }
      } else {
        this.moveModal = false;
        this.moveModal1 = true;
      }
    },
    // 创建标签
    createUserChooseTagParams() {
      let title = "",
        ids = "";
      this.selectedItems.forEach((item, index) => {
        if (index + 1 != this.selectedItems.length) {
          title = title + item.nickname + ",";
          ids = ids + item.uid + ",";
        } else {
          title = title + item.nickname;
          ids = ids + item.uid;
        }
      });
      return { title, ids };
    },
    cancel(type) {
      if (type == 1) {
        this.moveModal1 = false;
      } else {
        this.moveModal = false;
      }
      this.selectData = [];
    },
    deleteTag(id) {
      this.$http.delete(`/api/messageTag/${id}`).then(() => {
        this.getTag(this.id);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.v-content {
  text-align: left;
  font-size: 16px !important;
  padding: 15px;
  background: #fff;
}

.ivu-checkbox-group-item {
  position: relative;
  padding: 0 10px;
  .delete-tag {
    display: none;
    position: absolute;
    top: 2px;
    right: 0;
    font-size: 12px;
  }
  &:hover .delete-tag {
    display: block;
  }
}

.checkbox {
  display: flex;
  button {
    margin-left: 20px;
  }
}
.sm-title {
  color: #ccc;
  font-size: 12px;
}
.submit {
  text-align: center;
  button {
    margin: 0 20px;
  }
}
.avatar {
  max-height: 64px;
}
</style>
